const spaceDetailsSearchParamKeys = ['day', 'end', 'start', 'step'] as const

type SearchParams = Pick<URLSearchParams, 'get' | 'getAll'>

/**
 * Keep only the query parameters the space detail page needs to prefill a
 * booking. Copying the full query string makes tracking and referral
 * parameters spread across otherwise canonical public URLs.
 */
export const getSpaceDetailsSearch = (searchParams: SearchParams) => {
	const params = new URLSearchParams()

	for (const key of spaceDetailsSearchParamKeys) {
		const values = searchParams.getAll(key)

		for (const value of values) {
			params.append(key, value)
		}
	}

	return params.toString()
}
